/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface ZocdocBookingContent {
  specialty_id: string;
  visit_reason_id: string;
  insurance_plan_id?: string | null;
  final?: boolean;
}
